export const toggleFav = (payload) => {
    return {
        type: "TOGGLE_FAV",
        payload
    };
};
